import { IOnInit } from "angular";
import * as angular from 'angular';
import { FeesRepo } from '@services/fees.repo'
import { FeeType, FeeTier } from '@models/fees/fee.models'
import { extractErrorMessage } from '@common/utils/errorUtils';

class AddFeeTypeDialogController implements IOnInit {

  public feeType: FeeType;
  public isLoading: boolean = false;
  public title: string;
  public isFeeTypeFormValid: boolean = false;

  /** @ngInject */
  constructor(private $mdDialog: angular.material.IDialogService, private notifyjs, private feesRepo: FeesRepo) {}

  $onInit() {
    this.title = this.feeType && this.feeType.id ? `Edit ${this.feeType.name}` : 'Add Fee Type';
  }

  onFormValidChange = (isValid: boolean) => {
    this.isFeeTypeFormValid = isValid;
  }

  cancel = () => {
    this.$mdDialog.hide();
  }

  save = () => {
    this.isLoading = true;
    const feeTypePayload: FeeType = angular.copy(this.feeType);
    if (!this.feeType.isTiered) {
      feeTypePayload.feeTiers = [];
    } else {
      const feeTiers: Array<FeeTier> = this.feeType.feeTiers.map(ft => ({
        low: ft.low,
        high: ft.high == null ? 0 : ft.high,
        value: ft.value / 100,
        id: -1
      }));
      feeTypePayload.feeTiers = feeTiers;
    }

    if (feeTypePayload.id) {
      this.editFeeType(feeTypePayload);
    } else {
      this.feesRepo.saveFeeType(feeTypePayload)
        .then(() => {
          this.isLoading = false;
          this.$mdDialog.hide(true);
        })
        .catch(err => {
          this.isLoading = false;
          this.notifyjs(`Failed to save fee type - ${extractErrorMessage(err)}`, 'error');
        });
    }
  }

  editFeeType = (feeType: FeeType) => {
    this.feesRepo.editFeeType(feeType)
      .then(() => {
        this.isLoading = false;
        this.$mdDialog.hide(true);
      })
      .catch(err => {
        this.isLoading = false;
        this.notifyjs(`Failed to save fee type - ${extractErrorMessage(err)}`, 'error');
      });
  }
}

export const addFeeTypeDialog: angular.IComponentOptions = {
  template: require('./addFeeType.dialog.html'),
  controller: AddFeeTypeDialogController,
  bindings: {
    feeType: "<",
  }
}



// WEBPACK FOOTER //
// ./src/app/fees/feeTypeManagement/addFeeTypeDialog/addFeeType.dialog.ts